import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment-duration-format';

interface Duration extends moment.Duration {
  format: (template?: string, precision?: number, settings?: DurationSettings) => string;
}

interface DurationSettings {
  forceLength: boolean;
  precision: number;
  template: string;
  trim: boolean | 'left' | 'right';
}

@Pipe({ name: 'trTimeDelta' })
export class TimeDeltaPipe implements PipeTransform {
  transform(value: number): string {
    const msPerMin = 60000;
    const delta = Math.round(Number(value) / msPerMin);

    const duration = moment.duration(delta, 'minutes') as Duration;
    return duration.format('d [days], h [hr] m [min]');
  }
}
